import Plyr from 'plyr';
export default () =>{
    const postPlayer = document.querySelectorAll('[data-video-article]');

    postPlayer.length > 0? activateVideo():false;

    function activateVideo(){
        postPlayer.forEach(el => {
            const player = new Plyr(el, {
                hideControls:false,
                
                loop: {
                    active: true
                },
                storage: {
                    enabled: false
                },
                fullscreen: {
                    enabled: true,
                    iosNative: true
                }
            });

            const closeVideo = document.querySelectorAll('[data-teaser-close]');

            closeVideo.length > 0?closeHandle():false;

            function closeHandle(){
                closeVideo.forEach(item =>{
                    item.addEventListener('click', () =>{
                        player.stop();
                    })
                })
            }


        })
    }
    const homePlayer = document.querySelector('[data-plyr-home]');

    homePlayer?homePlayerHandle():false;

    function homePlayerHandle(){
        const homeWrapper =  document.querySelector('[data-video-wrapper]');
        const button =  homeWrapper.querySelector('[data-video-button]');
        const close =  homeWrapper.querySelector('[data-home-close]');

        const player = new Plyr(homePlayer, {
            hideControls: true,
            controls: [],
            muted: true,
            autoplay: true,
            
            loop: {
                active: true
            },
            storage: {
                enabled: false
            },
            fullscreen: {
                enabled: true,
                iosNative: true
              }
        });

        player.on('ready', ()=>{
            player.play()
        })

        button.addEventListener('click', ()=>{
            homeWrapper.classList.add('fixed');
            document.body.style.overflow = 'hidden'
            player.muted = false;
            player.play();
        })

        close.addEventListener('click', (e) =>{
            if (homeWrapper.classList.contains('fixed')){
                closeWindow()
            }
        })

        homeWrapper.addEventListener('click', (e) =>{
            if (homeWrapper.classList.contains('fixed')){
                if (e.target == homeWrapper){
                    closeWindow()
                }
            }
        })

        document.querySelectorAll("video")[0].addEventListener('webkitendfullscreen', ()=>{
            closeWindow()
        });

        function closeWindow(){
            homeWrapper.classList.remove('fixed');
            player.muted = true;
            document.body.style.overflow = 'auto'
        }
    }
}

